import Styled from 'styled-components';

export const InboxButtonContainer = Styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.davysGrey};
  color: ${(props) => props.theme.colors.davysGrey};
  background: transparent;
  cursor: pointer;
`;
